import type { Feed, FeedClass } from 'constants/payloads/realtime';

export function shouldExpectRealtimeAuth(
  feed: Feed,
  viewerId: string,
  feedClass?: FeedClass,
): boolean {
  return viewerId !== '' && (feed === 'darkpool' || (feed === 'flow' && feedClass === 'full'));
}

export function shouldReconnectRealtimeOnAuthChange(feed: Feed): boolean {
  return feed !== 'prices';
}

export function shouldAllowAnonymousRealtimeFallback(feed: Feed, feedClass?: FeedClass): boolean {
  return feed === 'prices' || (feed === 'flow' && feedClass !== 'full');
}

export function feedRequiresSnapshotDecompression(feed: Feed): boolean {
  return feed !== 'prices';
}
